'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
var Country;
(function (Country) {
    Country["SWEDEN"] = "SE";
    Country["NORWAY"] = "NO";
    Country["FINLAND"] = "FI";
    Country["UNITED_KINGDOM"] = "GB";
    Country["ALBANIA"] = "AL";
    Country["ANDORRA"] = "AD";
    Country["ARGENTINA"] = "AR";
    Country["AUSTRIA"] = "AT";
    Country["AUSTRALIA"] = "AU";
    Country["BAHRAIN"] = "BH";
    Country["BANGLADESH"] = "BD";
    Country["BELARUS"] = "BY";
    Country["BOLIVIA"] = "BO";
    Country["BOSNIA_AND_HERZEGOVINA"] = "BA";
    Country["BRAZIL"] = "BR";
    Country["BRUNEI_DARUSSALAM"] = "BN";
    Country["CANADA"] = "CA";
    Country["CHILE"] = "CL";
    Country["COLOMBIA"] = "CO";
    Country["CROATIA"] = "HR";
    Country["DENMARK"] = "DA";
    Country["ESTONIA"] = "EE";
    Country["FALKLAND_ISLANDS"] = "FK";
    Country["GEORGIA"] = "GE";
    Country["GERMANY"] = "DE";
    Country["GIBRALTAR"] = "GI";
    Country["GUERNSEY"] = "GG";
    Country["HEARD_ISLAND_AND_MCDONALD_ISLANDS"] = "HM";
    Country["HUNGARY"] = "HU";
    Country["ICELAND"] = "IS";
    Country["INDIA"] = "IN";
    Country["IRELAND"] = "IE";
    Country["ISLE_OF_MAN"] = "IM";
    Country["JAPAN"] = "JP";
    Country["JERSEY"] = "JE";
    Country["KOREA"] = "KR";
    Country["LATVIA"] = "LV";
    Country["LIECHTENSTEIN"] = "LI";
    Country["LITHUANIA"] = "LT";
    Country["LUXEMBOURG"] = "LU";
    Country["MACAO"] = "MO";
    Country["MACEDONIA"] = "MK";
    Country["MALTA"] = "MT";
    Country["MEXICO"] = "MX";
    Country["MOLDOVA"] = "MD";
    Country["MONACO"] = "MC";
    Country["MONGOLIA"] = "MN";
    Country["MONTENEGRO"] = "ME";
    Country["NETHERLANDS"] = "NL";
    Country["NEW_ZEALAND"] = "NZ";
    Country["PARAGUAY"] = "PY";
    Country["PERU"] = "PE";
    Country["PHILIPPINES"] = "PH";
    Country["SPAIN"] = "ES";
    Country["QATAR"] = "QA";
    Country["ROMANIA"] = "RO";
    Country["RUSSIA"] = "RU";
    Country["SAN_MARINO"] = "SM";
    Country["SERBIA"] = "RS";
    Country["SOUTH_AFRICA"] = "ZA";
    Country["SRI_LANKA"] = "LK";
    Country["SWITZERLAND"] = "CH";
    Country["TAIWAN"] = "TW";
    Country["THAILAND"] = "TH";
    Country["UKRAINE"] = "UA";
    Country["UNITED_ARAB_EMIRATES"] = "AE";
    Country["UNITED_STATES"] = "US";
    Country["VENEZUELA"] = "VE";
    Country["VIETNAM"] = "VN";
})(Country = exports.Country || (exports.Country = {}));
